import type { PhoneApi } from "../../api/PhoneApi";
import type { CreatePhone } from "../../generated/dto/CreatePhone";
import type { DeletePhoneStaff } from "../../generated/dto/DeletePhoneStaff";
import type { PhoneSearchParams } from "../../generated/dto/PhoneSearchParams";
import type { PhoneStaff } from "../../generated/dto/PhoneStaff";
import type { PhoneStaffSearchResult } from "../../generated/dto/PhoneStaffSearchResult";
import type { UpdatePhone } from "../../generated/dto/UpdatePhone";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class PhoneFrontendService {
  constructor(private readonly api: PhoneApi) {}
  async getPhoneStaff(id: number): Promise<PhoneStaff> {
    return this.api.getPhoneStaff(id)
  }
  async createPhoneStaff(source: CreatePhone): Promise<PhoneStaff> {
    return this.api.createPhoneStaff(source)
  }
  async updatePhoneStaff(source: UpdatePhone): Promise<PhoneStaff> {
    return this.api.updatePhoneStaff(source)
  }
  async deletePhoneStaff(source: DeletePhoneStaff): Promise<void> {
    return this.api.deletePhoneStaff(source)
  }
  async searchPhoneStaff(params: PhoneSearchParams, page: number, perPage: number): Promise<PaginationResult<PhoneStaffSearchResult>> {
    return this.api.searchPhoneStaff(params, page, perPage)
  }
  async searchPhoneStaffFull(params: PhoneSearchParams, page: number, perPage: number): Promise<PaginationResult<PhoneStaff>> {
    return this.api.searchPhoneStaffFull(params, page, perPage)
  }
}
